import {get} from 'lodash';

import CheckboxField from 'components/CheckboxField';
import Typography from 'components/Typography';

import {Order, OrderType} from 'types';

import styles from './InboxTicket.module.scss';
import classNames from 'classnames';
import StatusBadge from 'components/StatusBadge';
import {PinIcon} from 'pages/DeliveryPlanner/components/OrderDetailsModal/icons';
import ChainIcon from 'pages/DeliveryPlanner/icons/chain';

interface TicketProps {
  ticket: Order;
  index?: number;
  selected?: boolean;
  onChangeCheckbox: (id: number, checked: boolean) => void;
  isError?: boolean;
}

function Ticket({ticket, index, selected, onChangeCheckbox}: TicketProps) {
  const delivery_address = ticket?.delivery_address;
  const id = ticket?.id;

  const customer = ticket?.customer;
  const order_type = ticket?.order_type;
  const sequential_order_number = ticket?.orders?.[0]?.sequential_order_number;
  const pickup_number = ticket?.orders?.[0]?.pickup;
  const hasPickup = order_type === 'dropoff' && pickup_number !== null;

  const renderOrderType = (order_type?: OrderType) => {
    if (order_type === 'pickup') {
      return (
        <StatusBadge color="default" className={styles.orderTypeBadge}>
          P{sequential_order_number}
        </StatusBadge>
      );
    }
    if (order_type === 'dropoff') {
      return (
        <StatusBadge color="green" className={styles.orderTypeBadge}>
          C{sequential_order_number}
        </StatusBadge>
      );
    }
    return null;
  };
  return (
    <div
      className={classNames(
        styles.root,
        // Add border color for invalid addresses or error states
        typeof delivery_address !== 'string' &&
          !delivery_address?.is_valid &&
          styles.borderColor
      )}
    >
      <div style={{marginBottom: index ? 0 : 8}} className={styles.top}>
        {/* Checkbox for order selection */}
        <CheckboxField
          name={`checkbox-${id}`}
          className={styles.checkbox}
          label={`#${sequential_order_number}`}
          checked={selected}
          onChange={() => onChangeCheckbox(id, !selected)}
        />
        {typeof customer === 'string' ? (
          <Typography className={styles.customer} variant="p">
            {customer}
          </Typography>
        ) : (
          <Typography className={styles.customer} variant="p">
            {get(customer, 'user.first_name', '')}{' '}
            {get(customer, 'user.last_name', '')}
          </Typography>
        )}
        {renderOrderType(order_type)}
      </div>

      {hasPickup && (
        <div className={styles.addressContainer}>
          <ChainIcon className={styles.pinIcon} />
          <Typography
            className={styles.addressCalc}
            variant="p"
            style={{marginTop: 0}}
          >
            Associated Pickup: #{pickup_number}
          </Typography>
        </div>
      )}
      {typeof delivery_address === 'string' ? (
        <div className={styles.addressContainer}>
          <PinIcon className={styles.pinIcon} />
          <Typography className={styles.addressCalc} variant="p">
            {delivery_address}
          </Typography>
        </div>
      ) : (
        <div className={styles.addressContainer}>
          <PinIcon className={styles.pinIcon} />
          {delivery_address?.display_address && (
            <Typography className={styles.address} variant="p">
              {delivery_address?.display_address}
            </Typography>
          )}
          {!delivery_address?.display_address && (
            <Typography className={styles.address} variant="p">
              {[
                delivery_address?.address_line_1,
                delivery_address?.address_line_2,
                delivery_address?.city,
                delivery_address?.state,
                delivery_address?.zipcode,
              ]
                .filter(Boolean)
                .join(', ')}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
}

export default Ticket;
